export class ListDataCatalogNamespacesRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "parentPath",
            "baseName": "parentPath",
            "type": "Array<string>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListDataCatalogNamespacesRequest.attributeTypeMap;
    }
    constructor() {
    }
}
